import type {
  AuthorizationContext,
  AuthorizationRepository,
} from "@/data/repositories/authorizationRepository";
import { supabase } from "@/lib/supabase/client";
import type { EventRoleKey, OrganizationRoleKey } from "@/types/domain/rbac";

interface AuthorizationContextRow {
  organization_roles?: OrganizationRoleKey[];
  event_roles?: EventRoleKey[];
}

export class SupabaseAuthorizationRepository implements AuthorizationRepository {
  async getContext(organizationId: string, eventId?: string): Promise<AuthorizationContext> {
    const { data, error } = await supabase.rpc("get_my_authorization_context", {
      p_organization_id: organizationId,
      p_event_id: eventId ?? null,
    });

    if (error) throw error;
    const row = (data ?? {}) as AuthorizationContextRow;
    return {
      organizationRoles: row.organization_roles ?? [],
      eventRoles: row.event_roles ?? [],
    };
  }
}

